export const to12Hour = (h: number): number => {
  if (h > 12) return h - 12;
  if (h === 0) return 12;
  return h;
};

export const formatMinutes = (minutes: number): string => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  const period = h < 12 ? "am" : "pm";
  return `${to12Hour(h)}:${String(m).padStart(2, "0")}${period}`;
};
